import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { timeZoneMap } from "@web-app/utils/helpers";

interface TrackingPageTimelineTzProps {
  date: Date;
  timezone?: keyof typeof timeZoneMap;
}

export default function TrackingPageTimelineTz({
  date,
  timezone,
}: TrackingPageTimelineTzProps) {
  const { getTimezone } = useTimezone();
  const orderTimezone = getTimezone(timezone);

  // Convert UTC time directly to formatted strings in the specified timezone
  const dateFormatted =
    orderTimezone === "system"
      ? dayjs(date).format("MMMM DD, YYYY,")
      : dayjs.utc(date).tz(orderTimezone).format("MMMM DD, YYYY,");

  const timeFormatted =
    orderTimezone === "system"
      ? dayjs(date).format("hh:mm A")
      : dayjs.utc(date).tz(orderTimezone).format("hh:mm A");

  return (
    <>
      <div>{dateFormatted}</div>
      <div>{timeFormatted}</div>
    </>
  );
}
